<template>
    <section class="py-12 bg-white lg:py-16">
        <div class="px-4 mx-auto max-w-screen-md sm:px-6 xl:px-0">
            <div class="text-center">
                <h4 :class="newStyle ? 'text-45' : 'md:text-4xl xl:text-45 text-3xl'"
                    class="mb-10 font-bold leading-tight text-black font-ww-bold xl:leading-none" v-html="title">
                </h4>

                <div class="mb-12">
                    <div class="mx-auto custom-new-style-button" :class="newStyle ? 'buttonHealthyIcon' : ''">
                        <ButtonHealthyIcon :text="buttonText" :scroll-trigger="scrollTrigger" />
                    </div>
                </div>

                <div class="text-left">
                    <div class="mb-6 text-black lg:mb-10 font-ww-regular"
                        :class="newStyle ? 'text-xl' : 'md:text-xl text-lg'" v-html="signOff"></div>

                    <div class="flex flex-col gap-4 items-start">
                        <div class="">
                            <nuxt-img :src="image" :alt="name" class="" loading="lazy" width="260" height="217"
                                format="webp" />
                        </div>

                        <div>
                            <div class="font-bold text-black font-ww-bold"
                                :class="newStyle ? 'text-xl' : 'md:text-xl text-lg'" v-html="name"></div>
                            <div class="mt-3 text-black lg:mt-6 font-ww-regular"
                                :class="newStyle ? 'text-xl md-max:mt-6' : 'md:text-xl text-lg'" v-html="role">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    newStyle: { type: Boolean, default: false },
    title: {
        type: String,
        default: 'Ready To Experience Cleaner, Easy On The Gut Coffee That Tastes Incredible?'
    },
    buttonText: {
        type: String,
        default: 'SAVE BIG ON YOUR FIRST ORDER'
    },
    scrollTrigger: {
        type: String,
        default: '#offer-section'
    },
    signOff: {
        type: String,
        default: 'Sincerely,'
    },
    image: {
        type: String,
        default: '/assets/images/dr-charles-livingston.png'
    },
    name: {
        type: String,
        default: 'Dr. Charles Livingston'
    },
    role: {
        type: String,
        default: 'Founder of Lifeboost Coffee'
    }
});

defineBuilderComponent({
    friendlyName: 'Personal CTA',
    inputs: [
        {
            name: 'newStyle',
            type: 'boolean',
            defaultValue: false,
            friendlyName: 'New Style'
        },
        {
            name: 'title',
            type: 'text',
            defaultValue: 'Ready To Experience Cleaner, Easy On The Gut Coffee That Tastes Incredible?',
            friendlyName: 'Title'
        },
        {
            name: 'buttonText',
            type: 'text',
            defaultValue: 'SAVE BIG ON YOUR FIRST ORDER',
            friendlyName: 'Button Text'
        },
        {
            name: 'scrollTrigger',
            type: 'text',
            defaultValue: '#offer-section',
            friendlyName: 'Button Scroll Target (ID)'
        },
        {
            name: 'signOff',
            type: 'text',
            defaultValue: 'Sincerely,',
            friendlyName: 'Sign Off'
        },
        {
            name: 'image',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/dr-charles-livingston.png',
            friendlyName: 'Image'
        },
        {
            name: 'name',
            type: 'text',
            defaultValue: 'Dr. Charles Livingston',
            friendlyName: 'Name'
        },
        {
            name: 'role',
            type: 'text',
            defaultValue: 'Founder of Lifeboost Coffee',
            friendlyName: 'Role'
        }
    ]
});
</script>

<style>
@media (max-width: 1024px) {
    .buttonHealthyIcon button {
        font-size: 39px !important;
        line-height: 40px !important;
        padding: 24px 8px !important;
    }

    .buttonHealthyIcon button svg {
        width: 80px !important;
    }


}
</style>